<template>
  <section class="-wrapper-tile -wrapper-column fitting- -border-radius-1">
    <div class="-header no-border-">
      <p class="-h2 -font-weight-medium">{{ $t('pages_sales_info_invoice.title') }}</p>
    </div>
  <div>
        <div class="-tile-container -bg-white">
          <div class="-wrapper-between">
<!--            <div class="dropDown-wrap custom-select">-->
<!--              <g-dropdown-->
<!--                style="padding: 5px;width: 20%"-->
<!--                id="dashboard-payment-chart-select-month"-->
<!--                v-model="category"-->
<!--                text-class="-mx-0 -pr-0 -pl-2">-->
<!--                <g-dropdown-item-wrap class="-bg-white -box-shadow-level-4">-->
<!--                  <g-dropdown-item value="month" text="" :text="$t('pages_sales_info_invoice.month')"></g-dropdown-item>-->
<!--                  <g-dropdown-item value="invoiceNumber" text="" :text="$t('pages_sales_info_invoice.invoice_no')"></g-dropdown-item>-->
<!--                  <g-dropdown-item value="invoiceDate" text="" :text="$t('pages_sales_info_invoice.invoice_date')"></g-dropdown-item>-->
<!--                </g-dropdown-item-wrap>-->
<!--              </g-dropdown>-->
<!--            </div>-->
            <g-search-bar
              id="sales-info-invoice-list-search-text"
              no-border
              full
              placeholder="Search anything"
              v-model="searchText" />
            <g-button
              id="sales-info-invoice-list-download-button"
              variant="borderless"
              size="small"
              icon-only
              class="-mt-2 -minus-ml-2"
              @click="onClickDownload">
              <g-icon name="get_app" color="gray-1" width="16px" height="16px"/>
            </g-button>
          </div>

          <ag-grid-vue
            id="sales-info-invoice-list-grid"
            :dom-layout="domLayout"
            class="ag-theme-balham"
            row-height="30"
            header-height="30"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefs"
            :gridOptions="gridOptions"
            :rowData="invoices.invoices"
            :overlayLoadingTemplate="overlayLoadingTemplate"
            :loadingOverlayComponent="loadingOverlayComponent"
            :loadingOverlayComponentParams="loadingOverlayComponentParams"
            :overlayNoRowsTemplate="overlayNoRowsTemplate"
            :noRowsOverlayComponent="noRowsOverlayComponent"
            :noRowsOverlayComponentParams="noRowsOverlayComponentParams"
            :frameworkComponents="frameworkComponents"
            :modules="modules"
            :suppressPaginationPanel="true"
            :suppressScrollOnNewData="true"
            @row-data-changed="onRowDataChanged"
            @grid-ready="onGridReady">
          </ag-grid-vue>
        </div>
      </div>
  </section>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import { mapActions, mapGetters } from 'vuex'
import AgGridMixin from "@/pages/mixin/AgGrid.mixin"
import BadgeCell from "@/pages/components/ag-grid/BadgeCell"
import {CURRENCY_SYMBOL} from "@/constants/constants"
import BillDetailPopup2 from "@/pages/bill/components/BillDetailPopup2";
import LinkCell from "@/pages/components/ag-grid/LinkCell";
import ButtonCell from "@/pages/components/ag-grid/ButtonCell";
import WrapperCell from "@/pages/components/ag-grid/WrapperCell";
import ConfirmPopup from "@/pages/components/ConfirmPopup";

export default {
  name: 'invoice-list',
  componentName: 'invoiceList',
  components: {AgGridVue},
  mixins: [AgGridMixin()],
  data () {
    return {
      searchText: '',
      columnDefs: [],
      category: 'month'
    }
  },
  computed: {
    ...mapGetters('bills', ['invoices', 'invoiceDetail']),
    ...mapGetters('user', ['userInfo'])
  },
  methods: {
    ...mapActions('bills', ['getInvoices', 'resendEmail', 'getInvoicesWithInvoiceNo', 'openDownLoadBill']),
    onGridReady (params) {
      this.setGridParams(params);
      this.fitGrid();
    },
    async resend(item){
      let confirmMessage = this.$t('pages_sales_info_invoice.number')+' '+item.invoiceNo+' '+this.$t('pages_sales_info_invoice.resend_req')

      this.$popupManager.open(ConfirmPopup, {
        text: confirmMessage,
        onConfirm: async () => {
          await this.resendEmail(item.invoiceNo)
        }
      })



    },
    numberSort (num1, num2) {
      return num1 - num2;
    },
    openPopup(item) {
      this.getInvoicesWithInvoiceNo(item.invoiceNo)
      this.$popupManager.open(BillDetailPopup2)
    },
    getDownload(item){
      this.openDownLoadBill(item)
    },
    onChangePageNo (pageNo) {
      this.paging.pageNo = pageNo;
      this.gridApi.paginationGoToPage(pageNo - 1);
      this.fitGrid()
    },
    onRowDataChanged () {
      this.fitGrid()
    },
    onSearch() {
      this.changeProducts()
    },
    rowClicked () {},
    onClickDownload () {
      let params = {
        fileName: 'invoice_list',
        allColumns: true
      }
      this.gridApi.exportDataAsCsv(params);
    },
    setColumn () {
      this.columnDefs = [
        {field: 'no', headerName: 'No.', unSortIcon: true, comparator: this.numberSort},
        {field: 'invoiceMonth', headerName: this.$t('pages_sales_info_invoice.month'), unSortIcon: true},
        {field: 'invoiceNo', headerName: this.$t('pages_sales_info_invoice.invoice_no'), unSortIcon: true,
          cellRendererFramework: LinkCell({callback: (params) => {
              this.openPopup(params.data)
            }})
        },
        {field: 'invoiceDate', headerName: this.$t('pages_sales_info_invoice.invoice_date'), unSortIcon: true},
        {
          field: 'totalTradeAmountByKrw',
          comparator: this.numberSort,
          cellStyle : {'text-align': "right" },
          headerName: this.$t('pages_sales_info_invoice.total_amount'),
          unSortIcon: true, cellRenderer: (params) => { return  CURRENCY_SYMBOL.KRW + parseInt(params.value).toLocaleString()}
        },
        {
          field: 'remainAmountByKrw',
          comparator: this.numberSort,
          cellStyle : {'text-align': "right" },
          headerName: this.$t('pages_sales_info_invoice.unpaid_amount'),
          unSortIcon: true, cellRenderer: (params) => { return  CURRENCY_SYMBOL.KRW + parseInt(params.value).toLocaleString() }
        },
        {
          headerName: this.$t('pages_sales_info_invoice.paid_status'),
          field: "receiveStatusName",
          unSortIcon: true,
          cellStyle : {"cursor":"pointer"},
          comparator: () => false,
          cellRenderer : parameter => {
            if( parameter.value ===this.$t('pages_sales_info_invoice.paid_status.before') ){
              return '<p class="-tag red-">'+parameter.value+'</p>';
            } else if( parameter.value === this.$t('pages_sales_info_invoice.paid_status.complete') ) {
              return '<p class="-tag green-">'+parameter.value+'</p>';
            } else if( parameter.value === this.$t('pages_sales_info_invoice.paid_status.notcomplete')) {
              return '<p class="-tag yellow-">'+parameter.value+'</p>';
            }

          }
        },
        {
          headerName: this.$t('pages_sales_info_invoice.etc_action'),
          unSortIcon: true,
          cellRendererFramework: WrapperCell([
            ButtonCell({
              classes: '-btn secondary- small- -px-1 -mr-2',
              html: '<span class="-font-size-12">'+ this.$t('pages_sales_info_invoice.resend') +'</span>',
              callback: (params) => {
                this.resend(params.data)
              }
            }),
            ButtonCell({
              classes: '-tile-btn -btn secondary- small- icon-only- -mr-0',
              html: '<span class="material-icons -color-gray-1" style="width: 16px; height: 16px;">get_app</span>',
              callback: (params) => {
                this.openDownLoadBill(params.data, this.userInfo.empNo)
              }
            }),
          ])
        }
      ]
    }
  },
  watch: {
    searchText () {
      this.gridOptions.api.setQuickFilter(this.searchText)
    },
    invoices() {
      let customerName = ''
      this.invoices.invoices.forEach(function(invoice, index){
        invoice.no = index + 1
        customerName = invoice.customerName
      })
      this.$emit('customerName', customerName)
      this.rowData = this.invoices.invoices
      if (this.invoices.invoices.length > 0) {
        this.gridApi.hideOverlay()
      } else {
        this.gridApi.showNoRowsOverlay()
      }
    }
  },
  beforeMount () {
    this.invoiceParam = this.$route.query
    this.getInvoices(this.invoiceParam)
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/sales/components/SalesInfoCostByInvoice.vue